import { createTermsTagsManager } from '../../utils/createTermsTagsManager';
import { GARAGE_MATERIALS_MAP_VALUE_TO_LABEL } from './constants';

export const garageMaterialTagsManager = createTermsTagsManager({
  jsonQueryKey: 'garage_material',
  mapValueToLabel: GARAGE_MATERIALS_MAP_VALUE_TO_LABEL,
  id: 'garageMaterial',
});
